import $ from 'jquery'

export let redirectUri;
export let clientId;

$.ajax({
    type: 'get',
    async: false,
    url: '/ip/ip.json',
    data: {},
    success: (res) => {
        // alert(JSON.stringify(res))
       
        redirectUri = res.LINX_REDIRECT_URI
        clientId = res.LINX_CLIENT_ID

    }
})




